import { Button, ButtonProps } from '@mui/material'
import { clear as clearOpportunity } from 'redux/reducers/opportunitySlice'
import { useAppDispatch } from 'hooks/redux-hooks'
import { clearOfficerDraftCache } from 'utils/officer-draft-cache'

interface Props extends ButtonProps {
  label: string
  startIcon?: any
}

function RoundClose(props: Props) {
  const { label, startIcon, onClick, ...buttonProps } = props
  const dispatch = useAppDispatch()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    localStorage.removeItem('ssmCertificateImage')
    localStorage.removeItem('ssmExtractionResponse')
    localStorage.removeItem('ssmDocumentDetails')
    localStorage.removeItem('uenNumber')
    localStorage.removeItem('ssmNumber')
    localStorage.removeItem('mysBusinessAddress')
    localStorage.removeItem('mysNatureOfBusiness')
    clearOfficerDraftCache()
    localStorage.removeItem('isExistingMerchant')
    localStorage.removeItem('opportunityFlowType')
    dispatch(clearOpportunity())
    onClick?.(e)
  }

  return (
    <Button
      startIcon={startIcon ? startIcon : null}
      variant='outlined'
      {...buttonProps}
      onClick={handleClick}
      sx={{
        borderRadius: '24px',
        borderColor: 'grey.50',
        textTransform: 'none',
        width: '100px',
        height: '32px',
        fontSize: '14px',
        ...props.sx,
      }}
    >
      {label}
    </Button>
  )
}
export default RoundClose
